import { render, staticRenderFns } from "./distribution-tree-amount.vue?vue&type=template&id=4bfc5364&"
import script from "./distribution-tree-amount.ts?vue&type=script&lang=js&"
export * from "./distribution-tree-amount.ts?vue&type=script&lang=js&"
import style0 from "./distribution-tree-amount.vue?vue&type=style&index=0&id=4bfc5364&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports